import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const ReactJS = () => {
  return (
    <StartInterviewLayout type="react" />
  )
}

export default ReactJS